import { Typography, TextField, Box, Tabs, Tab, Select, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import TemplateEditorAce from "../../../components/code/ace/template.editor";
import { useDataProvider } from "react-admin";

const TabPanel = ({
  children,
  value,
  index,
}: {
  children: React.ReactNode;
  value: number;
  index: number;
}) => {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const AIFileEdit: React.FC<{
  item: any;
  onChange: (updatedItem: any) => void;
}> = ({ item, onChange }) => {
  const [updatedItem, setUpdatedItem] = useState(item);
  const [activeTab, setActiveTab] = useState(0);
  const [fileOptions, setFileOptions] = useState<{ aifileinstanceId: string; name: string }[]>(
    []
  );
  const [integrationOptions, setIntegrationOptions] = useState<{ integrationId: string; name: string }[]>(
    []
  );
    const dataProvider = useDataProvider();
  
    // Fetch options for the file selector using the dataProvider
    useEffect(() => {
      const fetchFileOptions = async () => {
        try {
          const { data } = await dataProvider.getList("aifileinstance", {
            filter: { }, // Your filter logic
            pagination: { page: 1, perPage: 50 }, // Adjust pagination if needed
            sort: { field: "name", order: "ASC" }, // Sort options
          });
          setFileOptions(data); // Data should be an array of { id, name }
        } catch (error) {
          console.error("Failed to fetch file options:", error);
        }
      };
  
      fetchFileOptions();
    }, [dataProvider]);

      // Fetch options for the file selector using the dataProvider
      useEffect(() => {
        const fetchIntegrationOptions = async () => {
          try {
            const { data } = await dataProvider.getList("integration", {
              filter: { isShared: true }, // Your filter logic
              pagination: { page: 1, perPage: 50 }, // Adjust pagination if needed
              sort: { field: "name", order: "ASC" }, // Sort options
            });
            setIntegrationOptions(data); // Data should be an array of { id, name }
          } catch (error) {
            console.error("Failed to fetch integration options:", error);
          }
        };
    
        fetchIntegrationOptions();
      }, [dataProvider]);

  // Check if item is not available and return a fallback UI
  if (!item) {
    return <div>No file data available</div>;
  }

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  // Function to handle changes in the form
  const handleChange = (field: string, value: any) => {
    const newItem = { ...updatedItem, [field]: value };
    setUpdatedItem(newItem);
    onChange(newItem); // Call onChange to update the parent component
  };

  console.log('fileInstances', fileOptions);

  return (
    <Box
      sx={{
        padding: "16px",
      }}
    >
      <Typography variant="h6" gutterBottom>
        File
      </Typography>
      <TextField
        sx={{ width: "100%", marginBottom: "16px" }}
        label="Name"
        value={updatedItem.name}
        onChange={(e) => handleChange("name", e.target.value)}
      />
      <TextField
        multiline
        sx={{ width: "100%", marginBottom: "16px" }}
        label="Description"
        value={updatedItem.description}
        onChange={(e) => handleChange("description", e.target.value)}
      />
      <Typography variant="body1" sx={{ marginTop: "16px" }} gutterBottom>
        Instructions
      </Typography>
      <TemplateEditorAce
        value={updatedItem.instructionsTemplate}
        onChange={(value) => handleChange("instructionsTemplate", value)}
      />
      <Typography variant="body1" sx={{ marginTop: "16px" }} gutterBottom>
        Source
      </Typography>
      <Tabs value={activeTab} onChange={handleTabChange} aria-label="Form tabs">
        <Tab label="Stored File" />
        <Tab label="Integration" />
      </Tabs>
      <TabPanel value={activeTab} index={0}>
        <Typography variant="h6">Stored File</Typography>
        <Select
          value={updatedItem.aiFileInstanceId || ""}
          onChange={(e) => handleChange("aiFileInstanceId", e.target.value)}
          fullWidth
        >
          {fileOptions.map((option) => (
            <MenuItem key={option.aifileinstanceId} value={option.aifileinstanceId}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <Typography variant="h6">Integration</Typography>
        <TextField
        multiline
        sx={{ width: "100%", marginBottom: "16px" }}
        label="Webhook URL"
        value={updatedItem?.integrationConfig}
        onChange={(e) => handleChange("webhookUrl", e.target.value)}
      />
      </TabPanel>
    </Box>
  );
};

export default AIFileEdit;

/*import { useLocation, useNavigate } from "react-router-dom";
import {
  ArrayInput,
  Button,
  FormDataConsumer,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  useRecordContext,
} from "react-admin";
import { Typography } from "@mui/material";
import JsonEditorAce from "../../../components/code/ace/json.editor";
import TemplateEditorAce from "../../../components/code/ace/template.editor";

const AIFileEdit = () => {
  const location = useLocation();
  const aiFile = location.state?.item; // Access the passed module data

  if (!aiFile) {
    return <div>No file available</div>;
  }
  const attributes = [
    { source: "name", label: "Name" },
    { source: "description", label: "Description" },
  ];

  return (
    <SimpleForm record={aiFile}>
      <Typography variant="h6" gutterBottom>
        File
      </Typography>
      <TextInput   sx={{ width: '30em' }} source="name" label="Name" />
      <TextInput multiline  sx={{ width: '30em' }} source="description" label="Description" />
      <TemplateEditorAce source="instructionsTemplate" /> 
    </SimpleForm>
  );
};

export default AIFileEdit;
*/
